import request from '@/utils/request'
export function getPageData(params) {
  return request({
    url: '/api/andon/overview',
    method: 'get',
    params,
  })
}
export function getClo(params) {
  return request({
    url: '/api/andon/overview/clo',
    method: 'get',
    params,
  })
}
export function getCloList(params) {
  return request({
    url: '/api/andon/overview/clo/list',
    method: 'get',
    params,
  })
}
export function getAndonSummaryRow(params) {
  return request({
    url: '/api/andon/overview/summary/row',
    method: 'get',
    params,
  })
}
export function getAndonSummary(params) {
  return request({
    url: '/api/andon/overview/summary',
    method: 'get',
    params,
  })
}
